import { alpha3ToAlpha2Map } from './convertAlpha3ToAlpha2CountryCode.constants';

/**
 * Converts an ISO 3166-1 alpha-3 country code to an ISO 3166-1 alpha-2 country code
 *
 * @param alpha3Code The 3-letter country code to convert
 * @returns The corresponding 2-letter country code or undefined if not found
 */
export const convertAlpha3ToAlpha2CountryCode = (alpha3Code: string) => {
    if (!alpha3Code || alpha3Code.length !== 3) {
        return undefined;
    }

    return alpha3ToAlpha2Map[alpha3Code.toUpperCase()];
};
